<template>
  <li v-if="resource">
    <p
      v-for="(text, index) in resource.text"
      :key="index"
      class="mb-0 f-16"
      v-html="text"
    />
  </li>
</template>

<script>
export default {
    name: 'NoteTitle',
    computed: {
        resource () {
            return this.$store.getters['furtherStory/getQuestions'].title;
        }
    }
};
</script>

<style scoped></style>
